import React from 'react';

const textLayout = {
  vertical: {
    title: {
      textAnchor: 'start',
      x: 40,
    },
    attributes: {},
    attribute: {
      x: 40,
      dy: '1.2em',
    },
  },
  horizontal: {
    title: {
      textAnchor: 'start',
      y: 40,
    },
    attributes: {
      x: 0,
      y: 40,
    },
    attribute: {
      x: 0,
      dy: '1.2em',
    },
  },
};

const PureSvgNodeElement = ({ nodeDatum, orientation, toggleNode, onNodeClick, depth }) => {
  const style = {
    top: {
      y: -50,
      x: -150,
      width: 300
    },
    bottom: {
      y: 30,
      x: -40
    }
  }
  return (
    <>
      <circle r={20} onClick={toggleNode}></circle>
      <g className="rd3t-label">
        <foreignObject
          width="80"
          height="160"
          y={-10}
          {...(
            depth === 0 ?
              style.top :
              (
                nodeDatum.__rd3t.collapsed || !nodeDatum.children || nodeDatum.children?.length < 0 ?
                  style.bottom :
                  textLayout[orientation].title
              )
          )}
        >
          <p
            className="rd3t-label__title text-center"
            onClick={onNodeClick}
          >
            {nodeDatum.name}
          </p>
          <p className="rd3t-label__attributes">
            {nodeDatum.attributes &&
              Object.entries(nodeDatum.attributes).map(([labelKey, labelValue], i) => (
                <tspan key={`${labelKey}-${i}`} {...textLayout[orientation].attribute}>
                  {labelKey}: {labelValue}
                </tspan>
              ))}
          </p>
        </foreignObject>
      </g>
    </>
  );
};

export default PureSvgNodeElement;
